import React from "react";

const InfoLabel = ({ title }) => <p className="font-light pointer carbonic text-center text-5xl">{title}</p>;
export default InfoLabel;
